import { all, put, takeEvery } from "redux-saga/effects";
import { createProcedureHistory } from "../../Services/api";
import { getProceduresHistory } from "../../Services/database";
import { throwError } from "../../Services/error";
import { isValidObject } from "../../Services/validators";
import { locationRange } from "../../Utils/constants";
import { setErrorStatus, setSuccessStatus } from "../status/action";
import store from "../store";

export const actionTypes = {
  SET_OFFLINE_PROCEDURE_HISTORY: "SET_OFFLINE_PROCEDURE_HISTORY",
  GET_PROCEDURES_HISTORY_DATA: "GET_PROCEDURES_HISTORY_DATA",
  ADD_SELECTED_PROCEDURE: "ADD_SELECTED_PROCEDURE",
  COMPLETE_PROCEDURE: "COMPLETE_PROCEDURE"
};

function* getProceduresHistoryDataWorker(action) {
  try {
    yield setProceduresLoading(true);
    const result = yield getProceduresHistory(
      action.payload.procedureId,
      action.payload.locationId,
      store.getState().profile.data.employeeId
    );
    yield put({
      type: "SET_PROCEDURES_HISTORY_DATA",
      payload: { data: result }
    });
    yield setProceduresLoading(false);
  } catch (error) {
    yield setProceduresLoading(false);

    setErrorStatus(error, "getProceduresHistoryDataWorker");
  }
}

function* addSelectedProcedureWorker(action) {
  try {
    yield setProceduresLoading(true);
    yield put({
      type: "SET_SELECTED_PROCEDURE",
      payload: { data: action.payload.data }
    });
    yield setProceduresLoading(false);
  } catch (error) {
    yield setProceduresLoading(false);
    setErrorStatus(error, "addSelectedProcedureWorker");
  }
}

function* completeProcedureWorker(action) {
  try {
    yield setProceduresLoading(true);
    const locations = store.getState().locations;
    const procedures = store.getState().procedures;
    const employee = store.getState().profile.data;
    const selectedLocation = locations.data?.[locations.selectedLocation];
    const selectedProcedure =
      procedures.data?.[procedures.selectedProcedure?.procedureId];
    const authData = store.getState().auth.data;

    if (locations.distance === null || locations.distance > locationRange) {
      yield setProceduresLoading(false);
      throw throwError("custom", "You are not in location");
    }

    const procedureData = action.payload.data;

    let latestUpdateData = [];

    for (let i = 0; i < procedureData?.length; i++) {
      let totalKpi = null;

      if (
        procedureData[i]?.updatedRequiredRemarks &&
        procedureData[i]?.updatedRequiredRemarks.length > 0
      ) {
        procedureData[i].updatedRequiredRemarks.forEach((remark) => {
          if (remark.kpi) {
            totalKpi = {
              initial: totalKpi
                ? totalKpi.initial + remark.kpi.initial
                : remark.kpi.initial,
              final: totalKpi
                ? totalKpi.final + remark.kpi.final
                : remark.kpi.final
            };
          }
        });
      } else if (isValidObject(procedureData[i]?.kpi)) {
        if (procedureData[i].success) {
          totalKpi = procedureData[i]?.kpi;
        } else {
          totalKpi = { initial: 0, final: 0 };
        }
      }

      latestUpdateData.push({
        proof: procedureData[i].proof,
        success: procedureData[i].success,
        ...(procedureData[i].remarks
          ? { remarks: procedureData[i].remarks }
          : {}),
        ...(totalKpi ? { kpi: totalKpi } : {}),
        ...(procedureData[i].selectedPenalty
          ? { penalty: procedureData[i].selectedPenalty }
          : {}),
        ...(procedureData[i].updatedRequiredRemarks
          ? { requiredRemarks: procedureData[i].updatedRequiredRemarks }
          : {}),
        title: procedureData[i].title,
        description: procedureData[i].description
      });
    }

    const formData = new FormData();

    formData.append("createdAt", +new Date());

    formData.append(
      "employee",
      JSON.stringify({
        name: employee.name,
        phoneNumber: employee.phoneNumber,
        type: employee.type?.toLowerCase(),
        id: employee.employeeId
      })
    );

    formData.append(
      "location",
      JSON.stringify({
        PCTNo: selectedLocation?.PCTNo,
        ward: selectedLocation?.ward,
        address: selectedLocation?.location,
        zone: selectedLocation?.zone,
        id: selectedLocation?.documentId
      })
    );

    formData.append(
      "procedure",
      JSON.stringify({
        title: selectedProcedure.title,
        type: selectedProcedure.procedureType,
        id: procedures.selectedProcedure.procedureId
      })
    );

    const updatedLatestUpdateData = [];
    latestUpdateData.forEach((step, index) => {
      const { proof, ...metadata } = step;

      updatedLatestUpdateData.push({ ...metadata, proof: [] });

      if (Array.isArray(proof)) {
        proof.forEach((file, fileIndex) => {
          if (file instanceof File) {
            formData.append(`files[${index}][${fileIndex}]`, file);
          }
        });
      }
    });

    formData.append(`latestUpdate`, JSON.stringify(updatedLatestUpdateData));

    yield createProcedureHistory(formData, authData.accessToken);

    if (action.payload.navigate) {
      action.payload.navigate(
        `/procedures/${procedures.selectedProcedure.procedureId}/success`
      );
    } else {
      console.warn("there is no action.payload.navigate");
    }
    setSuccessStatus("Procedure completed successfully");

    yield setProceduresLoading(false);
  } catch (error) {
    yield setProceduresLoading(false);
    console.error(error, "from setProcedureHistory");
    setErrorStatus(error, "completeProcedureWorker");
  }
}

function* setOfflineProceduresHistoryDataWorker(action) {
  yield put({
    type: "PUT_OFFLINE_PROCEDURES_HISTORY",
    payload: action.payload.data
  });
}

export default function* proceduresWatcher() {
  yield all([
    takeEvery(
      "SET_OFFLINE_PROCEDURE_HISTORY",
      setOfflineProceduresHistoryDataWorker
    ),
    takeEvery("GET_PROCEDURES_HISTORY_DATA", getProceduresHistoryDataWorker),
    takeEvery("ADD_SELECTED_PROCEDURE", addSelectedProcedureWorker),
    takeEvery("COMPLETE_PROCEDURE", completeProcedureWorker)
  ]);
}

function* setProceduresLoading(bool) {
  yield put({
    type: "SET_PROCEDURES_LOADING",
    payload: {
      loading: bool
    }
  });
}
